/**
 * Text the UI translates: a string-table key with optional variables, or raw text
 * that's shown as is (player names, file names, debug output).
 */
export type LocalizedText =
  | { readonly key: string; readonly vars?: Readonly<Record<string, TextVar>> }
  | { readonly raw: string }

/** A variable's value. A `LocalizedText` is translated before it's filled in. */
export type TextVar = string | number | LocalizedText

export function text(key: string, vars?: Readonly<Record<string, TextVar>>): LocalizedText {
  return vars === undefined ? { key } : { key, vars }
}

export function raw(value: string): LocalizedText {
  return { raw: value }
}

/**
 * Translations keyed by dot paths (`menu.continue`, `error.bootFailed`). `{name}` in a value
 * is replaced from `LocalizedText.vars`. The UI has its own table; content brings another.
 */
export type StringTable = Readonly<Record<string, string>>
